import React from "react";
import {
    Card,
    CardContent,
    CircularProgress,
    Dialog,
    DialogContent,
    MenuItem,
} from "@mui/material";
import useLogAccessEvent from "../../../hooks/useLogAccessEvent";
import { useAuth0 } from "@auth0/auth0-react";
import { UserClaimsService } from "../../../services/currentUserService/currentUserService";

interface UserInfoMenuCardProps {
    onMenuClick: () => void;
    popoverRef: HTMLDivElement | null;
}

const UserInfoMenuCard: React.FC<UserInfoMenuCardProps> = (props) => {
    const [showLogoutSpinner, setShowLogoutSpinner] = React.useState<boolean>(false);

    const { logout } = useAuth0();
    const { logEvent } = useLogAccessEvent();

    const claimsService = new UserClaimsService();

    const logoutWithRedirect = () => {
        setShowLogoutSpinner(true);
        logEvent("UserLoggedOut", null);
        claimsService.ClearToken();
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    return (
        <Card sx={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 2, p: 0 }}>
            <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                <MenuItem
                    onClick={() => logoutWithRedirect()}
                    sx={{
                        fontSize: "13px",
                        py: 1,
                        minHeight: "unset",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        color: "text.secondary",
                    }}
                    dense
                >
                    <span>Logout</span>
                </MenuItem>
            </CardContent>
            {showLogoutSpinner ? (
                <Dialog open={true}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
            ) : null}
        </Card>
    );
};

export default UserInfoMenuCard;
